export const CREATE_EMISSION = `mutation createEmission(
  $input: EmissionRequestInput!
  $quotationId: Int
  $renovation_id: Int
  $pledgedCreditor: PledgedCreditorInput
  $naturalPerson: EmissionNaturalPersonInput
  $legalPerson: EmissionLegalPersonInput
  $legalRepresentative: LegalRepresentativeInput
  $foreign: Boolean
) {
  createEmission(
    input: $input
    renovation_id: $renovation_id
    quotationId: $quotationId
    pledgedCreditor: $pledgedCreditor
    naturalPerson: $naturalPerson
    legalPerson: $legalPerson
    legalRepresentative: $legalRepresentative
    foreign: $foreign
  ) {
    __typename
    ... on Emission {
      id
      id_policy
      error_notice
      id_policy_life
      obs_policy_life
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;
